import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Shifts = () => {
  const columns = [
    { key: 'name', label: 'Shift Name' },
    { key: 'from_time', label: 'From Time' },
    { key: 'to_time', label: 'To Time' },
    { key: 'description', label: 'Description' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'name', label: 'Shift Name', required: true, placeholder: 'Morning Shift' },
    { name: 'from_time', label: 'From Time', required: true, placeholder: '06:00', type: 'time' },
    { name: 'to_time', label: 'To Time', required: true, placeholder: '14:00', type: 'time' },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Shifts"
      endpoint="shifts"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN']}
      allowBulkUpload={false}
    />
  );
};

export default Shifts;
